@if (facade.lombard$ | async; as lombard) {
  <div class="tile">
    <h5 class="mb-2 font-medium">{{ 'lombard.teaser.headline' | transloco }}</h5>
    <p class="text-size-large">{{ 'lombard.teaser.body' | transloco }}</p>
    <div class="d-lg-flex justify-content-between mt-4">
      <div class="d-lg-flex">
        <div class="d-flex d-lg-block justify-content-between align-items-center mb-2 mb-lg-0">
          <div class="label">{{ 'lombard.teaser.maxCreditAmount' | transloco }}</div>
          <div class="value mt-0 mt-lg-2">{{ lombard.maxCreditAmount | number: '1.0-0' }}<sub>€</sub></div>
        </div>
        <div class="spacer hidden-xs hidden-sm hidden-md"></div>
        <div class="d-flex d-lg-block justify-content-between align-items-center mb-4 mb-lg-0">
          <div class="label">{{ 'lombard.teaser.creditInterest' | transloco }}</div>
          <div class="value mt-0 mt-lg-2">{{ lombard.creditInterest | number: '1.2-2' }}<sub>%</sub></div>
        </div>
      </div>
      <div class="d-lg-flex flex-column justify-content-between">
        <div>
          <button class="btn" [routerLink]="lombardUrl">{{ 'lombard.teaser.btn' | transloco }}</button>
        </div>
        <div class="text-center mt-2">
          <a class="link-secondary cursor-pointer" (click)="facade.dismissTeaser()">{{ 'lombard.teaser.dismiss' | transloco }}</a>
        </div>
      </div>
    </div>
  </div>
}
